import { InjectionToken } from '@angular/core';
import { DisplayService } from '@shared/services/display/display.service';

export const DisplayServiceInjectionToken = new InjectionToken<DisplayService<any>>('DISPLAY_SERVICE_TOKEN');
